import facebook from "../Assets/Img/facebook.png";
import utube from "../Assets/Img/utube.png";
import linkdin from "../Assets/Img/linkdin.png";
import graduate from "../Assets/Img/Graduate.png";
import whatsppp from "../Assets/Img/whatsppp.png";
import logo from "../Assets/Img/SmartBLogo.png";

const Footer = () => {
    return (
        <>
            <div className="smartB_footer">
                <div className="smartB_footer-secion">
                    <ul className="footer-menu_links">
                        <h3 className="links_heading">ERP</h3>
                        <li>
                            <a href="#">Product Overview</a>
                        </li>
                        <li>
                            <a href="#">Cloud ERP for Business</a>
                        </li>
                        <li>
                            <a href="#">Cloud ERP for Manufacturing</a>
                        </li>
                        <li>
                            <a href="#">Barcode Inventory Solution</a>
                        </li>
                        <li>
                            <a href="#">Cloud System for Hardware Store</a>
                        </li>
                        <li>
                            <a href="#">Custom Build / Design System</a>
                        </li>
                        <li>
                            <a href="#">Use Cases / Past Projects</a>
                        </li>
                    </ul>
                    <ul className="footer-menu_links">
                        <h3 className="links_heading">Solutions</h3>
                        <li>
                            <a href="#">Business Solutions</a>
                        </li>
                        <li>
                            <a href="#">Planning & Scheduling</a>
                        </li>
                        <li>
                            <a href="#">Business Intelligence & Analytics</a>
                        </li>
                        <li>
                            <a href="#">Performance Management</a>
                        </li>
                        <li>
                            <a href="#">Supply Chain Management</a>
                        </li>
                        <li>
                            <a href="#">Barcoding</a>
                        </li>

                    </ul>
                    <ul className="footer-menu_links">
                        <h3 className="links_heading">Task Automation</h3>
                        <li>
                            <a href="#">Robotic Process Automation</a>
                        </li>
                        <li>
                            <a href="#">MS Excel Training Workshop</a>
                        </li>
                        <li>
                            <a href="#"><h3 className="links_heading">SB Academy</h3></a>
                        </li>
                        <li>
                            <a href="#">Training ( open in new page )</a>
                        </li>
                    </ul>
                    <ul className="menu_links">
                        <h3 className="links_heading">Others</h3>
                        <li>
                            <a href="#">Contacts</a>
                        </li>
                        <li>
                            <a href="#">About</a>
                        </li>
                        <li>
                            <a href="#">Blog</a>
                        </li>
                        <li>
                            <a href="#">Testimonial</a>
                        </li>
                    </ul>

                </div>

                <div className="footer-bootom_section">
                    <div className="footer_image">
                        <a href="https://imgbb.com/"><img src={logo} /></a>
                        <h2>Infinite Possibilities <br /> with SmartB</h2>
                    </div>

                    <div className="footer_information">
                        <h1>Address</h1>
                        <p>Unit A211, 2nd Floor, Lift Lobby 3,</p>
                        <p>Block A, Damansara Intan E-Business Park,</p>
                        <p> 1, Jln SS 20/27, 47400</p>
                        <p>Petaling Jaya, Selangor, Malaysia.</p>
                        <div className='d-inline-flex col-12'>
                            <img src={facebook} className='logoSize mx-1' alt="" />
                            <img src={utube} className='logoSize mx-1' alt="" />
                            <img src={linkdin} className='logoSize mx-1' alt="" />
                            <img src={graduate} className='logoSize mx-1' alt="" />
                            <img src={whatsppp} className='logoSize mx-1' alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;